import {
  LOCALSTORAGE_DISCOUNT_CODE,
  LOCALSTORAGE_FIRST_ORDER_FORM_COLLECTIONS,
  LOCALSTORAGE_HOUSEHOLD_SIZE,
  LOCALSTORAGE_REGISTER_FLOW_MACHINE,
  LOCALSTORAGE_TAGS,
} from '@constants/localStorage';
import {
  SESSIONSTORAGE_REFERRAL,
  SESSIONSTORAGE_ENGAGED_FREETRIALER_CONFIRMATION,
} from '@constants/sessionStorage';
import { useAuthentication } from '@context/businessContainer';
import { useReferralContext } from '@context/referral';
import { useMembershipCouponContext } from '@context/membershipCoupon';
import { useApolloClient } from '@apollo/client';
import { DeliveryBarMachineContext } from '@monofront/business/contexts';
import { EVENTS } from '@monofront/business/stateMachines/deliveryBar';
import { getAuth, signOut } from '@firebase/auth';

export const useLogout = () => {
  const { setIsLogoutPending } = useAuthentication();
  const { clearContext: clearReferralContext } = useReferralContext();
  const { removeCoupon } = useMembershipCouponContext();
  const client = useApolloClient();
  const { send } = DeliveryBarMachineContext.useActorRef();

  const logout = async (callback?: () => Promise<any>) => {
    if (callback) {
      setIsLogoutPending?.(true);
      await callback();
    }

    removeCoupon();
    send({
      type: EVENTS.MACHINE_RESET,
      input: {
        address: null,
        shippingMethod: null,
        eligibleShippingMethods: [],
      },
    });
    sessionStorage.removeItem(SESSIONSTORAGE_REFERRAL);
    sessionStorage.removeItem(SESSIONSTORAGE_ENGAGED_FREETRIALER_CONFIRMATION);
    localStorage.removeItem(LOCALSTORAGE_DISCOUNT_CODE);
    localStorage.removeItem(LOCALSTORAGE_FIRST_ORDER_FORM_COLLECTIONS);
    localStorage.removeItem(LOCALSTORAGE_REGISTER_FLOW_MACHINE);
    localStorage.removeItem(LOCALSTORAGE_HOUSEHOLD_SIZE);

    clearReferralContext();
    localStorage.removeItem(LOCALSTORAGE_TAGS);
    window.dispatchEvent(new Event('local-storage'));
    client.clearStore();

    signOut(getAuth());

    if (callback) {
      setIsLogoutPending?.(false);
    }
  };

  return logout;
};
